import(/* webpackMode: "eager" */ "/work/apps/frontend/src/app/(buyer)/product/[id]/error.tsx");
